import React, { useState } from 'react';
import { useHistory, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Box from 'ui-box';
import { Row, Col, Typography, Button, Divider, Form, Input } from 'antd';
import { ClockCircleOutlined } from '@ant-design/icons';
import { ReactComponent as PlayCircleSvg } from '../../../../assets/icons/knowledge-bank/play-circle.svg';

import HeaderBack from '../../../../components/mobile/HeaderBack';

const { Search } = Input;
const { Title, Paragraph } = Typography;

const formItemLayout = {
  labelCol: {
    span: 24,
  },
  wrapperCol: {
    span: 24,
  },
}

const data = [
  {
    title: 'Audio Track 01',
    time: '10 mins 15 s',
    url: '/knowledge-bank/detail/audio/detail'
  },
  {
    title: 'Audio Track 02',
    time: '10 mins 15 s',
    url: '/knowledge-bank/detail/audio/detail'
  },
  {
    title: 'Audio Track 03',
    time: '5 mins 15 s',
    url: '/knowledge-bank/detail/audio/detail'
  },
  {
    title: 'Audio Track 04',
    time: '12 mins 11 s',
    url: '/knowledge-bank/detail/audio/detail'
  }
];

function MobileAudioHomeScreen() {
  const { t } = useTranslation(['knowledge-bank', 'common']);
  const history = useHistory();

  const onBack = () => {
    history.push('/knowledge-bank/detail')
  }

  const onReadMore = (url) => {
    history.push(url)
  }

  const VideoItem = ({item}) => {
    return (
      <Col xs={24}>
        <Box style={styles.box}>
          <Box paddingY={10} paddingX={15}>
            <Row align="middle" justify="center">
              <Col xs={12}>
                <Title level={4} style={styles.itemTitle} onClick={() => onReadMore(item.url)}>
                  {item.title}
                </Title>
                <Row align="middle" justify="start">
                  <ClockCircleOutlined style={{ marginRight: 10 }}/>
                  <Title level={4} style={styles.itemTime}>
                    {item.time}
                  </Title>
                </Row>
              </Col>
              <Col xs={12}>
                <Row align="middle" justify="end">
                  <PlayCircleSvg />
                </Row>
              </Col>
            </Row>
          </Box>
        </Box>
      </Col>
    )
  }

  return (
    <>
      <HeaderBack
        onBack={onBack}
        text={t('knowledge-bank:returnCovid')}
        title={t('knowledge-bank:audios.title')}
        subtitle={t('knowledge-bank:audios.subtitle')}
      />
      <Divider />
      <Box marginTop={26} marginBottom={26}>
        <Form.Item
          style={{ width: '100%', padding: '3%' }}
          formItemLayout={formItemLayout}
        >
          <Search placeholder={t('knowledge-bank:audios.search')} />
        </Form.Item>
      </Box>
      <Row>
        {data.map((item) => <VideoItem item={item} />)}
      </Row>
    </>
  );
}

const styles = {
  box: {
    background: "#FFFFFF", 
    border: "1px solid #D9D9D9", 
    boxSizing: "border-box", 
    borderRadius: "4px",
    marginBottom: 25
  },
  itemTitle: {
    fontWeight: "500", 
    fontSize: "16px", 
    lineHeight: "24px", 
    color: "#262626",
    marginBottom: 8
  },
  itemTime: {
    fontWeight: "300", 
    fontSize: "12px", 
    lineHeight: "19px", 
    textAlign: "center", 
    letterSpacing: "-0.04em", 
    color: "#8C8C8C",
    margin: 0
  }
};

export default MobileAudioHomeScreen;
